/**
 * Per-application semantic versions. Bump an app's version when that tool ships user-facing changes.
 * The suite banner uses SUITE_VERSION for the shared "Alpha" label until apps diverge.
 */
export const SUITE_VERSION = '0.3';

export const APP_VERSIONS = [
  { id: 'cross_sections', name: 'Cross sections', version: '0.1' },
  { id: 'beam_formulae', name: 'Beam calculator', version: '0.1' },
  { id: 'foundations', name: 'Foundation analysis', version: '0.2' },
  { id: 'composite_columns', name: 'Composite columns', version: '0.2' },
  { id: 'console', name: 'Console calculations', version: '0.1' },
  { id: 'slab_calculator', name: 'Slab analysis', version: '0.3' },
  { id: 'site_planner', name: 'Site planner', version: '0.3' },
  { id: 'truss', name: 'Truss & frame', version: '0.3' },
];

const _byId = Object.fromEntries(APP_VERSIONS.map((a) => [a.id, a.version]));

export function getAppVersion(appId) {
  return _byId[appId] ?? SUITE_VERSION;
}
